import React from "react";
import CreateTitle from "../../smart/buttonPopups/CreateTitle";
import { Table } from "../DataTable";

const Titles = props => {

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: "/PM/title/" + row.ID })}
        </React.Fragment>

    const titleContent = <CreateTitle />;

    return (
        <Table title="Titles" titleContent={titleContent} renderRow={renderRow} cols={[
            { name: "title id", sortCol: "ID" },
            { name: "title name", sortCol: "name" }
        ]} rows={props.rows} />
    )
}

export default Titles;